export default "__VITE_ASSET__9587bb70__"